
import { Plugins } from '@capacitor/core';
const { Geolocation } = Plugins;
/**
 * @description 
 * @param {function} success - Function to run on success
 * @param {function} error
 */
export default function agetLocation(success, error) {
    Geolocation.getCurrentPosition({
        enableHighAccuracy: false,
        timeout: 5000
    }).then(coords => {
        success({
            latitude: coords.coords.latitude,
            longitude: coords.coords.longitude
        })
    }).catch(e => {
        navigator.geolocation.getCurrentPosition(coords => {
            success({
                latitude: coords.coords.latitude,
                longitude: coords.coords.longitude
            })
        }, () => {
            success({
                latitiude: 40.398857,
                longitude: -105.052643
            })
        }, {
            enableHighAccuracy: false,
            timeout: 5000,
            maximumAge: 0
        });
    })
}